<aside class="chat-side" [attr.aria-label]="'chatAi.sidebar.ariaLabel' | translate">

  <!-- ── Tabs: Chat | Agentes ──────────────────────────────────── -->
  <div class="chat-side__tabs">
    <button type="button" class="chat-side__tab"
            [class.active]="activeTab === 'chat'"
            (click)="activeTab = 'chat'; tabChange.emit('chat')">
      💬 {{ 'chatAi.tabs.chat' | translate }}
    </button>
    <button type="button" class="chat-side__tab"
            [class.active]="activeTab === 'agents'"
            (click)="activeTab = 'agents'; tabChange.emit('agents')">
      🤖 {{ 'chatAi.tabs.agents' | translate }}
    </button>
  </div>

  <!-- ── Delete confirmation popup ─────────────────────────────── -->
  <div *ngIf="confirmingId"
       class="chat-side__popup-overlay"
       role="alertdialog"
       [attr.aria-label]="'chatAi.drawer.deleteConfirmAriaLabel' | translate"
       (click)="onCancelDelete()">
    <div class="chat-side__popup" (click)="$event.stopPropagation()">
      <p class="chat-side__popup-msg">{{ 'chatAi.drawer.deleteConfirm' | translate }}</p>
      <div class="chat-side__popup-actions">
        <button type="button" class="chat-side__popup-btn"
                (click)="onCancelDelete()">
          {{ 'chatAi.drawer.deleteConfirmNo' | translate }}
        </button>
        <button type="button" class="chat-side__popup-btn chat-side__popup-btn--danger"
                (click)="onConfirmDelete(confirmingId)">
          {{ 'chatAi.drawer.deleteConfirmYes' | translate }}
        </button>
      </div>
    </div>
  </div>

  <!-- ═══ TAB: Chat (conversations list) ═══════════════════════ -->
  <ng-container *ngIf="activeTab === 'chat'">
    <button type="button" class="chat-side__new" (click)="newChat.emit()">
      + {{ 'chatAi.sidebar.newChat' | translate }}
    </button>
    <input class="chat-side__search"
           type="search"
           [(ngModel)]="query"
           [placeholder]="'chatAi.sidebar.searchPlaceholder' | translate"
           [attr.aria-label]="'chatAi.sidebar.searchPlaceholder' | translate" />
    <div class="chat-side__filters">
      <button type="button" class="chat-side__filter-chip"
              [class.active]="filterMode === 'all'"
              (click)="filterMode = 'all'">{{ 'chatAi.sidebar.filterAll' | translate }}</button>
      <button type="button" class="chat-side__filter-chip"
              [class.active]="filterMode === 'today'"
              (click)="filterMode = 'today'">{{ 'chatAi.sidebar.filterToday' | translate }}</button>
      <button type="button" class="chat-side__filter-chip"
              [class.active]="filterMode === 'week'"
              (click)="filterMode = 'week'">{{ 'chatAi.sidebar.filterWeek' | translate }}</button>
    </div>
    <div class="chat-side__list">
      <ng-container *ngFor="let group of groups; trackBy: trackByLabel">
        <h5 class="chat-side__group">{{ group.label | translate }}</h5>
        <div *ngFor="let c of group.items; trackBy: trackById"
             class="chat-side__item"
             [class.active]="c.id === activeId"
             [class.editing]="editingId === c.id">
          <button type="button"
                  class="chat-side__item-hit"
                  *ngIf="editingId !== c.id"
                  (click)="pick.emit(c.id)"
                  [title]="c.title">
            <span class="chat-side__item-title"
                  [attr.role]="c.id === activeId ? 'button' : null"
                  [attr.tabindex]="c.id === activeId ? 0 : null"
                  [attr.aria-label]="c.id === activeId ? ('chatAi.sidebar.renameAria' | translate) : null"
                  (click)="onTitleClick($event, c)">
              {{ c.title }}
            </span>
          </button>
          <button type="button"
                  class="chat-side__item-delete"
                  *ngIf="editingId !== c.id"
                  (click)="onDelete($event, c.id)"
                  [attr.aria-label]="'chatAi.sidebar.deleteAria' | translate"
                  title="Delete">
            &times;
          </button>
          <input *ngIf="editingId === c.id"
                 #titleInput
                 [attr.data-id]="c.id"
                 type="text"
                 class="chat-side__item-input"
                 [(ngModel)]="editingValue"
                 [maxlength]="titleMaxLength"
                 (keydown)="onEditKey($event)"
                 (blur)="commitEdit()"
                 [attr.aria-label]="'chatAi.sidebar.renameAria' | translate" />
        </div>
      </ng-container>
      <p *ngIf="groups.length === 0" class="chat-side__empty">
        {{ 'chatAi.sidebar.empty' | translate }}
      </p>
    </div>
  </ng-container>

  <!-- ═══ TAB: Agents — informational hint (directory shown in main area) ═══ -->
  <div class="chat-side__agents-hint" *ngIf="activeTab === 'agents'">
    <p>{{ 'chatAi.agentHub.selectHint' | translate }}</p>
  </div>
</aside>
